import Image from 'next/image'
import { useRouter } from 'next/router'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

import Breadcrumbs from '@/atoms/Breadcrumb'
import Button from '@/atoms/Button/Button'

import BenefitTile from './common/BenefitTile'
import Section from './common/Section'
import VioletSection from './common/VioletSection'
import { WellBeingListItem } from './common/WellBeingListItem'
import { getList } from './functions'
import MainBanner from './MainBanner'

function ForBrands() {
  const { push } = useRouter()
  const { t } = useTranslation('forBrands')
  const list = getList(t)

  return (
    <div>
      <Breadcrumbs
        crumbs={[{ label: t('global:for_brands') }]}
        className="mb-8"
      />
      <article className="xl:-mb-32">
        <MainBanner />
        <Section title={t('what_can_we_offer_you')}>
          <>
            <ul className="grid grid-cols-1 mb-10 lg:grid-cols-2 lg:grid-rows-4 lg:grid-flow-col gap-y-14 gap-x-14 ">
              {list.map(({ imageKey, title, description }, index) => (
                <BenefitTile
                  key={index}
                  imageKey={imageKey}
                  title={title}
                  description={description}
                />
              ))}
              <div className="self-end row-span-3">
                <img
                  src="/images/for-brands/artists.png"
                  className="bottom-0 right-0 -mb-10"
                />
              </div>
            </ul>
          </>
        </Section>
        <Section variant="green" title={t('co-features')}>
          <div className="flex flex-col items-center mb-10 space-y-6">
            <p className="max-w-4xl text-lg text-center">
              <Trans
                i18nKey="forBrands:co-features_info_1"
                components={[<b key={0} className="text-black-500" />]}
              />
            </p>
            <p className="max-w-4xl text-lg text-center">
              <Trans
                i18nKey="forBrands:co-features_info_2"
                components={[<b key={0} className="text-black-500" />]}
              />
            </p>
            <p className="max-w-4xl text-lg text-center">
              {t('co-features_info_3')}
            </p>
            <Image
              src="/images/for-brands/gadgets.png"
              width={800}
              height={400}
              quality={75}
              loading="eager"
            />
            <span className="text-center">
              <h2 className="mb-1 text-3xl font-medium">
                {t('co-features_benefits_header')}
              </h2>
              <ul className="text-lg">
                {t('co-features_benefits')
                  .split('\n')
                  .map((line) => (
                    <li key={line}>{line}</li>
                  ))}
              </ul>
            </span>
            <span className="max-w-2xl">
              <Image
                src="/images/for-brands/benefits.png"
                width={1370}
                height={384}
                quality={75}
                loading="eager"
              />
            </span>
          </div>
        </Section>
        <Section title={t('well_being_what_it_is')}>
          <div className="flex flex-col items-center max-w-5xl mx-auto mb-10 space-y-10 text-lg text-center">
            <p>
              <Trans
                i18nKey="forBrands:well_being_what_it_is_desc"
                components={[<b key={0} className="text-black-500" />]}
              />
            </p>
            <div className="flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/2">
                <Image
                  src="/images/for-brands/well-being.png"
                  width={1400}
                  height={1000}
                  quality={75}
                  loading="eager"
                />
              </div>
              <div className="flex flex-col items-start justify-center w-full space-y-2 lg:w-1/2">
                <p className="font-bold text-left">
                  {t('well_being_list_title')}
                </p>
                <WellBeingListItem text="well_being_list_1" />
                <WellBeingListItem text="well_being_list_2" />
                <WellBeingListItem text="well_being_list_3" />
                <WellBeingListItem text="well_being_list_4" />
                <WellBeingListItem text="well_being_list_5" />
                <WellBeingListItem text="well_being_list_6" />
              </div>
            </div>
          </div>
        </Section>
        <Section variant="green" title={<VioletSection />}>
          <div className="flex flex-col items-center text-center md:mt-12 md:mb-32">
            <h2 className="mb-4 text-5xl font-medium md:text-6xl">
              {t('contact_with_us')}
            </h2>
            <p className="mb-8 text-xl">
              Wspólnie wybierzemy najlepsze rozwiązanie dla Twojego biznesu
            </p>
            <Button
              text={t('contact_us')}
              variant="flat"
              className="py-3 !text-lg hover:!bg-[#4ccec3] bg-[#85cfc4] !text-white px-11 lg:py-4 md:px-20 md:text-base"
              onClick={() => push('/contact')}
            />
          </div>
        </Section>
      </article>
    </div>
  )
}

export default ForBrands
